import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Label from 'components/_utility/Label';

import SummaryBikeCard from 'src/components/_steps/BikeSummary/SummaryBikeCard/SummaryBikeCard';
import SummaryColourCard from 'src/components/_steps/BikeSummary/SummaryColourCard/SummaryColourCard';
import SummaryAccessoryCard from 'src/components/_steps/BikeSummary/SummaryAccessoryCard/SummaryAccessoryCard';
import SummaryPackCard from 'src/components/_steps/BikeSummary/SummaryPackCard/SummaryPackCard';
import LuxuryTaxTotal from 'components/LuxuryTaxTotal/LuxuryTaxTotal';

import { bikeSummaryAccessoriesSelector, getPack, getPackAndAccessoriesTotal } from 'src/redux/bike/selectors';
import { disclaimerSelector } from 'src/redux/app/selectors';
import ArrowUp from 'src/assets/icons/arrow-up.svg';
import ArrowDown from 'src/assets/icons/arrow-down.svg';
import {
  BackButton,
  BackButtonInner,
  BackLabel,
  Wrap,
  Outer,
  Content,
  Title,
  BackToTop,
  SummaryToggleDesktop,
} from 'components/_steps/BikeSummary/BikeSummary.styled';
import { ChevronLeft } from '@material-ui/icons';
import { currentStepSelector } from 'src/redux/configurator/selectors';
import { setStep } from 'src/redux/configurator/actions';
import SummaryActions from './SummaryActions/SummaryActions';

const BikeSummary = ({ bikeViewportRef, summaryHeadingRef, isSimulationChecksumExists, openShareModal }) => {
  const accessories = useSelector(bikeSummaryAccessoriesSelector);
  const disclaimer = useSelector(disclaimerSelector);
  const hasPack = useSelector(getPack);
  const packAndAccessoriesTotal = useSelector(getPackAndAccessoriesTotal);
  const activeStepNumber = useSelector(currentStepSelector);
  const dispatch = useDispatch();

  const scrollToSummary = () => {
    const summaryHeadingEl = summaryHeadingRef.current;
    summaryHeadingEl.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const bikeViewportEl = bikeViewportRef.current;
    bikeViewportEl.scrollTo(0, 0);
  }, []);

  const handlePrevClick = () => {
    dispatch(setStep(activeStepNumber - 1));
  };

  return (
    <Wrap>
      <SummaryActions
        isSimulationChecksumExists={isSimulationChecksumExists}
        openShareModal={openShareModal}
        mobileOnly
      ></SummaryActions>
      <Title ref={summaryHeadingRef}>
        <Label name="bikeSummaryLabel" />
        <SummaryToggleDesktop onClick={scrollToSummary}>
          <ArrowDown></ArrowDown>
        </SummaryToggleDesktop>
      </Title>
      <BackButton onClick={handlePrevClick}>
        <BackButtonInner>
          <ChevronLeft />
          <BackLabel>
            <Label name="backToConfiguratorLabel" />
          </BackLabel>
        </BackButtonInner>
      </BackButton>
      <Outer>
        <Content>
          {disclaimer.showLuxuryTaxDisclaimers ? <SummaryBikeCard /> : null}
          <SummaryColourCard />
          {hasPack ? <SummaryPackCard /> : null}
          {accessories.length ? <SummaryAccessoryCard /> : null}
          {disclaimer.showLuxuryTaxDisclaimers && (accessories.length || hasPack) ? (
            <LuxuryTaxTotal type="accessoriesPrice" price={packAndAccessoriesTotal} label="packAndAccessoriesLabel" />
          ) : null}
        </Content>
      </Outer>
      {accessories.length > 4 ? (
        <BackButton onClick={handlePrevClick}>
          <BackButtonInner>
            <ChevronLeft />
            <BackLabel>
              <Label name="backToConfiguratorLabel" />
            </BackLabel>
          </BackButtonInner>
        </BackButton>
      ) : null}
      <BackToTop onClick={() => scrollToTop()}>
        <Label name="backToTopLabel" />
        <ArrowUp></ArrowUp>
      </BackToTop>
    </Wrap>
  );
};

export default BikeSummary;
